export default __webpack_public_path__ + "static/media/Exxon.83c41cda.png";